/**
 * Scenty enhancements for Recharge bundle (scent picker) page.
 * Syncs sticky mobile continue bar with Recharge widget state.
 * Search + category filtering for scent grid.
 */
(function () {
  if (!document.body.classList.contains('template-product-recharge-bundle')) return;

  var BAR_ID = 'sc-scent-bar';
  var FALLBACK_ID = 'sc-scent-fallback';
  var SKELETON_ID = 'sc-scent-skeleton';
  var COUNTDOWN_SECONDS = 5;
  var statusEl, statusPlaceholderEl, statusSelectionEl, statusItemsEl, statusThumbEl, statusNameEl;
  var ctaEl, cancelEl, ctaLabelEl, ctaProgressEl;
  var planMeta = { priceLabel: '', title: '', priceAmount: null, handle: '' };
  var planMetaLoaded = false;
  var rechargeBtn = null;
  var syncing = false;
  var ctaLoading = false;
  var ctaLoadingTimer = null;
  var CTA_LOADING_TIMEOUT_MS = 15000;
  var countdown = {
    timer: null,
    remaining: 0,
    cancelled: false,
    selectionKey: ''
  };
  var barDebounceTimer = null;
  var widgetObserver = null;
  var footerObserver = null;
  var filterState = { query: '', category: 'alle' };
  var catalogByTitle = {};
  var catalogLoaded = false;
  var filterReady = false;
  var productsStableTimer = null;
  var lastProductCount = 0;
  var productsTagged = false;

  var CATEGORY_KEYWORDS = {
    blomster: [
      'bloom', 'flower', 'floral', 'florale', 'rose', 'jasmin', 'jasmine', 'peony', 'pivoine',
      'gardenia', 'lily', 'lilje', 'blomst', 'blomster', 'fleur', 'blossom', 'magnolia',
      'orchid', 'violet', 'tuberose', 'iris', 'freesia', 'ylang', 'chanel no 5', 'coco mademoiselle',
      'flowerbomb', 'daisy', 'la vie est belle', 'angel', 'good girl'
    ],
    frisk: [
      'fresh', 'frisk', 'ocean', 'marine', 'aquatic', 'aquatisk', 'clean', 'sport', 'light blue',
      'cool water', 'acqua', 'sea', 'hav', 'air', 'breeze', 'drift', 'cool', 'energy', 'pulse',
      'ck one', 'ck be', '212', 'escape', 'polo sport', 'invictus aqua'
    ],
    orientalsk: [
      'oriental', 'amber', 'vanilla', 'vanilje', 'honey', 'honning', 'gourmand', 'sweet', 'sød',
      'sugar', 'night', 'noir', 'intense', 'absolu', 'opium', 'black opium', 'scandal', 'olympea',
      'good girl', 'fantasy', 'sugar', 'candy', 'prada candy', 'heat', 'fever', 'euphoria'
    ],
    tra: [
      'wood', 'woody', 'træ', 'trae', 'cedar', 'cedarwood', 'sandalwood', 'santal', 'vetiver',
      'leather', 'læder', 'laeder', 'suede', 'moss', 'pine', 'fyr', 'santal', 'oud', 'bois',
      'sauvage', 'bleu de chanel', 'terre', 'encre', 'fahrenheit', 'allure homme sport'
    ],
    citrus: [
      'citrus', 'citron', 'lemon', 'orange', 'bergamot', 'grapefruit', 'mandarin', 'lime',
      'neroli', 'grapefruit', 'acqua di gio', 'light blue', 'ck one', 'cologne', 'limoncello',
      'fierce', 'million', 'eros'
    ],
    krydret: [
      'spice', 'spicy', 'kryd', 'pepper', 'peber', 'cinnamon', 'kanel', 'tobacco', 'røg',
      'rog', 'smoke', 'incense', 'cardamom', 'clove', 'nutmeg', 'pepper', 'pepper', 'the one',
      'spicebomb', 'la nuit', 'noir', 'kouros', 'azzaro'
    ]
  };

  var normalizedKeywords = {};
  Object.keys(CATEGORY_KEYWORDS).forEach(function (category) {
    normalizedKeywords[category] = CATEGORY_KEYWORDS[category].map(normalizeText);
  });

  var GENDER_KEYWORDS = {
    mand: [
      'homme', 'men', 'man', 'masculin', 'pour homme', 'for men', 'sauvage', 'bleu de chanel',
      'fahrenheit', 'kouros', 'azzaro', 'invictus', 'eros', 'one million', 'spicebomb', 'polo',
      'allure homme', 'la nuit', 'terre dhermes', 'encre noire'
    ],
    kvinde: [
      'femme', 'women', 'woman', 'pour femme', 'for her', 'mademoiselle', 'coco mademoiselle',
      'flowerbomb', 'good girl', 'angel', 'olympea', 'daisy', 'bloom', 'la vie est belle',
      'chanel no 5', 'miss dior', 'black opium', 'scandal'
    ]
  };

  var normalizedGenderKeywords = {};
  Object.keys(GENDER_KEYWORDS).forEach(function (gender) {
    normalizedGenderKeywords[gender] = GENDER_KEYWORDS[gender].map(normalizeText);
  });

  var SCENT_QUIZ_PROFILES = {
    frisk: ['frisk', 'citrus'],
    blomstret: ['blomster'],
    warm: ['orientalsk', 'tra', 'krydret']
  };

  var SCENT_QUIZ_OCCASION = {
    dag: ['frisk', 'citrus', 'blomster'],
    aften: ['orientalsk', 'tra', 'krydret']
  };

  function normalizeText(value) {
    return (value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function loadPlanMeta() {
    if (planMetaLoaded) return;
    planMetaLoaded = true;

    var node = document.getElementById('sc-scent-plan');
    if (!node) return;

    try {
      var data = JSON.parse(node.textContent || '{}');
      planMeta.priceLabel = data.priceLabel || '';
      planMeta.title = data.title || '';
      planMeta.priceAmount = data.priceAmount || null;
      planMeta.handle = data.handle || '';
    } catch (error) {
      planMeta = { priceLabel: '', title: '', priceAmount: null, handle: '' };
    }
  }

  function getPlanPriceLabel() {
    loadPlanMeta();
    var label = planMeta.priceLabel || '';
    if (
      window.ScentyCampaignDiscount &&
      planMeta.priceAmount &&
      typeof window.ScentyCampaignDiscount.getDiscountedDisplayForAmount === 'function'
    ) {
      var display = window.ScentyCampaignDiscount.getDiscountedDisplayForAmount(planMeta.priceAmount, '/md');
      if (display) return display.textMd;
    }
    if (
      window.ScentyCampaignDiscount &&
      label &&
      typeof window.ScentyCampaignDiscount.parsePriceAmount === 'function'
    ) {
      var amount = window.ScentyCampaignDiscount.parsePriceAmount(label);
      if (amount) {
        var discounted = window.ScentyCampaignDiscount.getDiscountedDisplayForAmount(amount, '/md');
        if (discounted) return discounted.textMd;
      }
    }
    return label;
  }

  function getPlanPriceSummary() {
    loadPlanMeta();
    var amount = planMeta.priceAmount || null;
    if (
      !amount &&
      window.ScentyCampaignDiscount &&
      typeof window.ScentyCampaignDiscount.parsePriceAmount === 'function'
    ) {
      amount = window.ScentyCampaignDiscount.parsePriceAmount(planMeta.priceLabel);
    }
    if (
      window.ScentyCampaignDiscount &&
      amount &&
      typeof window.ScentyCampaignDiscount.getDiscountedDisplayForAmount === 'function'
    ) {
      var display = window.ScentyCampaignDiscount.getDiscountedDisplayForAmount(amount, '/md');
      if (display) {
        return {
          current: display.textMd,
          original: (amount + ' kr/md'),
          hasDiscount: true
        };
      }
    }
    return {
      current: planMeta.priceLabel || '',
      original: '',
      hasDiscount: false
    };
  }

  function isComboPlan() {
    loadPlanMeta();
    if (planMeta.handle === '1-valgfri-1-overraskelse') return true;
    return window.location.pathname.indexOf('/products/1-valgfri-1-overraskelse') !== -1;
  }

  function formatBarSummary(scentTitle) {
    var summary = getPlanPriceSummary();
    var price = summary.hasDiscount ? summary.current : getPlanPriceLabel();
    var title = (scentTitle || '').trim();
    if (price && title) return price + ' · ' + title;
    if (title) return title;
    if (price) return price + ' · Vælg en duft';
    return 'Vælg en duft';
  }

  function createBarSelectionItem(scent, options) {
    var opts = options || {};
    var item = document.createElement('div');
    item.className =
      'sc-scent-bar__item' + (opts.surprise ? ' sc-scent-bar__item--surprise' : '');

    if (opts.surprise) {
      var icon = document.createElement('span');
      icon.className = 'sc-scent-bar__item-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">' +
        '<polyline points="20 12 20 22 4 22 4 12"/>' +
        '<rect x="2" y="7" width="20" height="5"/>' +
        '<line x1="12" y1="22" x2="12" y2="7"/>' +
        '<path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>' +
        '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>' +
        '</svg>';

      var surpriseName = document.createElement('span');
      surpriseName.className = 'sc-scent-bar__item-name';
      surpriseName.textContent = scent.title || 'Overraskelse';

      item.appendChild(icon);
      item.appendChild(surpriseName);
      return item;
    }

    if (scent.imageSrc) {
      var img = document.createElement('img');
      img.className = 'sc-scent-bar__thumb';
      img.width = 40;
      img.height = 40;
      img.decoding = 'async';
      img.src = scent.imageSrc;
      img.alt = scent.title || '';
      item.appendChild(img);
    }

    var label = document.createElement('span');
    label.className = 'sc-scent-bar__item-name';
    label.textContent = scent.title || 'Duft valgt';
    item.appendChild(label);
    return item;
  }

  function renderComboBarSelection(chosenScent) {
    if (!statusItemsEl) return;

    statusItemsEl.innerHTML = '';

    var price = getPlanPriceLabel();
    if (price) {
      var priceLine = document.createElement('div');
      priceLine.className = 'sc-scent-bar__price-line';
      priceLine.textContent = price;
      statusItemsEl.appendChild(priceLine);
    }

    var list = document.createElement('div');
    list.className = 'sc-scent-bar__item-list';
    list.appendChild(createBarSelectionItem(chosenScent));
    list.appendChild(
      createBarSelectionItem({ title: 'Overraskelse' }, { surprise: true })
    );
    statusItemsEl.appendChild(list);
  }

  function loadCatalog() {
    if (catalogLoaded) return;
    catalogLoaded = true;

    var node = document.getElementById('sc-scent-catalog');
    if (!node) return;

    try {
      var items = JSON.parse(node.textContent || '[]');
      items.forEach(function (item) {
        var key = normalizeText(item.title);
        if (key) catalogByTitle[key] = item;
      });
    } catch (error) {
      catalogByTitle = {};
    }
  }

  function lookupCatalogText(title) {
    var key = normalizeText(title);
    if (catalogByTitle[key]) {
      return normalizeText(catalogByTitle[key].title + ' ' + (catalogByTitle[key].text || ''));
    }
    return key;
  }

  function detectCategories(text) {
    var normalized = normalizeText(text);
    var categories = [];

    Object.keys(normalizedKeywords).forEach(function (category) {
      var keywords = normalizedKeywords[category];
      for (var i = 0; i < keywords.length; i++) {
        if (normalized.indexOf(keywords[i]) !== -1) {
          categories.push(category);
          break;
        }
      }
    });

    return categories;
  }

  function getCardTitle(card) {
    var titleEl = card.querySelector('.rb-item-title, [class*="title"], h3, h4, .sc-scent-fallback__title');
    return titleEl ? (titleEl.textContent || '').trim() : '';
  }

  function tagFilterableItem(item) {
    if (item.getAttribute('data-sc-categories')) return;

    var title = item.getAttribute('data-scent-title') || getCardTitle(item);
    var searchText =
      item.getAttribute('data-sc-search-text') ||
      lookupCatalogText(title) ||
      normalizeText(title);
    var categories = detectCategories(searchText);

    item.setAttribute('data-sc-search-text', searchText);
    item.setAttribute('data-sc-categories', categories.join(','));
  }

  function isFallbackActive() {
    var fallback = document.getElementById(FALLBACK_ID);
    return !!(fallback && !fallback.hidden);
  }

  function findProductCards() {
    var bundleItems = Array.prototype.slice.call(
      document.querySelectorAll('.recharge-bundle-product-item')
    );
    if (bundleItems.length) return bundleItems;

    return Array.prototype.slice.call(document.querySelectorAll('.rb-item')).filter(function (item) {
      return (
        item.closest('.rb-items, .recharge-bundle-products-container, .rb-items-wrapper') &&
        !item.closest('.rb-header, .rb-sticky-form, .rb-footer')
      );
    });
  }

  function getFilterableItems() {
    if (isFallbackActive()) {
      return Array.prototype.slice.call(
        document.querySelectorAll('.sc-scent-fallback__card')
      );
    }
    return findProductCards();
  }

  function tagAllFilterableItems(force) {
    if (!force && productsTagged) return;
    var items = getFilterableItems();
    if (!items.length) return;

    if (!isFallbackActive()) loadCatalog();

    items.forEach(tagFilterableItem);
    productsTagged = true;
  }

  function itemMatchesFilter(item) {
    var searchText = item.getAttribute('data-sc-search-text') || '';
    var categories = (item.getAttribute('data-sc-categories') || '').split(',').filter(Boolean);
    var query = normalizeText(filterState.query);

    if (query && searchText.indexOf(query) === -1) return false;

    if (filterState.category !== 'alle' && categories.indexOf(filterState.category) === -1) {
      return false;
    }

    return true;
  }

  function filterScents(query, category) {
    filterState.query = query != null ? query : filterState.query;
    filterState.category = category != null ? category : filterState.category;

    tagAllFilterableItems(true);

    var allItems = getFilterableItems();
    var visible = 0;

    allItems.forEach(function (item) {
      var show = itemMatchesFilter(item);
      item.classList.toggle('sc-scent-hidden', !show);
      if (show) visible += 1;
    });

    updateFilterCount(visible, allItems.length);
  }

  function updateFilterCount(visible, total) {
    var countEl = document.querySelector('[data-sc-scent-count]');
    if (!countEl) return;

    if (!total) {
      countEl.textContent = '';
      return;
    }

    if (visible === total && !filterState.query && filterState.category === 'alle') {
      countEl.textContent = 'Viser alle ' + total + ' dufte';
      return;
    }

    countEl.textContent = 'Viser ' + visible + ' af ' + total + ' dufte';
  }

  function getFlowHeaderOffset() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--sc-flow-header-offset');
    var parsed = parseFloat(raw);
    return Number.isFinite(parsed) ? parsed : 110;
  }

  function scrollToFilteredResults() {
    var anchor =
      document.querySelector('.rb-items-wrapper') ||
      document.querySelector('.recharge-bundle-products-container') ||
      document.querySelector('[data-sc-scent-grid]') ||
      document.querySelector('.sc-scent-picker__inner') ||
      document.getElementById('sc-scent-picker');
    if (!anchor) return;

    var headerOffset = getFlowHeaderOffset();
    var filter = document.querySelector('[data-sc-scent-filter]');
    var filterHeight = filter ? filter.getBoundingClientRect().height : 0;
    var gap = 8;
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var targetTop = anchor.getBoundingClientRect().top + scrollY - headerOffset - filterHeight - gap;

    if (scrollY <= targetTop + 12) return;

    window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
  }

  function initFilterPin() {
    var filter = document.querySelector('[data-sc-scent-filter]');
    var flowHeader = document.querySelector('.sc-flow-header');
    if (!filter || !flowHeader || filter.dataset.pinInit === 'true') return;
    filter.dataset.pinInit = 'true';

    var sentinel = document.createElement('div');
    sentinel.className = 'sc-scent-filter__sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    filter.parentNode.insertBefore(sentinel, filter);

    var headerSpacer = document.createElement('div');
    headerSpacer.className = 'sc-flow-header__spacer';
    headerSpacer.setAttribute('aria-hidden', 'true');
    flowHeader.insertAdjacentElement('afterend', headerSpacer);

    var filterSpacer = document.createElement('div');
    filterSpacer.className = 'sc-scent-filter__spacer';
    filterSpacer.setAttribute('aria-hidden', 'true');
    filter.insertAdjacentElement('afterend', filterSpacer);

    var pinned = false;
    var rafId = null;

    function usesFixedChrome() {
      return window.matchMedia('(max-width: 900px)').matches;
    }

    function usesCompactHeader() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function measureHeaderHeight() {
      return Math.max(0, Math.round(flowHeader.getBoundingClientRect().height));
    }

    function syncChromePosition() {
      var headerHeight = measureHeaderHeight();
      document.documentElement.style.setProperty('--sc-flow-header-offset', headerHeight + 'px');

      if (pinned && usesFixedChrome()) {
        filter.style.top = headerHeight + 'px';
      } else if (!pinned) {
        filter.style.top = '';
      }
    }

    function updateSpacers(active) {
      if (!active) {
        headerSpacer.style.height = '0';
        filterSpacer.style.height = '0';
        return;
      }

      filterSpacer.style.height = filter.offsetHeight + 'px';

      if (usesFixedChrome()) {
        headerSpacer.style.height = measureHeaderHeight() + 'px';
      } else {
        headerSpacer.style.height = '0';
      }
    }

    function setCompact(shouldCompact) {
      if (!usesCompactHeader()) {
        flowHeader.classList.remove('is-compact');
        return;
      }
      flowHeader.classList.toggle('is-compact', shouldCompact);
    }

    function setPinned(shouldPin) {
      if (shouldPin === pinned) {
        syncChromePosition();
        if (pinned && usesFixedChrome()) updateSpacers(true);
        return;
      }

      pinned = shouldPin;

      if (shouldPin && usesCompactHeader()) {
        setCompact(true);
        void flowHeader.offsetHeight;
      }

      filter.classList.toggle('is-pinned', shouldPin);
      flowHeader.classList.toggle('is-filter-pinned', shouldPin);
      flowHeader.classList.toggle('is-chrome-fixed', shouldPin && usesFixedChrome());
      document.body.classList.toggle('sc-filter-pinned', shouldPin);

      if (!shouldPin) {
        setCompact(false);
        filter.style.top = '';
      } else {
        updateSpacers(true);
        if (!usesFixedChrome()) {
          requestAnimationFrame(function () {
            updateSpacers(true);
          });
        }
      }

      syncChromePosition();

      if (!shouldPin && usesCompactHeader()) {
        requestAnimationFrame(syncChromePosition);
      }
    }

    function checkPinState() {
      if (!usesFixedChrome()) {
        flowHeader.classList.remove('is-compact', 'is-chrome-fixed');

        var desktopShouldPin = sentinel.getBoundingClientRect().top <= measureHeaderHeight();
        setPinned(desktopShouldPin);
        return;
      }

      if (usesCompactHeader() && pinned) {
        setCompact(true);
      }

      var headerBottom = flowHeader.getBoundingClientRect().bottom;
      var shouldPin = sentinel.getBoundingClientRect().top <= headerBottom + 0.5;

      setPinned(shouldPin);

      if (pinned) {
        updateSpacers(true);
        syncChromePosition();
      }
    }

    function schedulePinCheck() {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        checkPinState();
      });
    }

    window.addEventListener('scroll', schedulePinCheck, { passive: true });
    window.addEventListener('resize', schedulePinCheck, { passive: true });

    if ('ResizeObserver' in window) {
      var chromeResizeObserver = new ResizeObserver(schedulePinCheck);
      chromeResizeObserver.observe(flowHeader);
      chromeResizeObserver.observe(filter);
    }

    flowHeader.addEventListener('transitionend', schedulePinCheck);
    checkPinState();
  }

  function bindFilterControls() {
    var filterRoot = document.querySelector('[data-sc-scent-filter]');
    if (!filterRoot || filterRoot.dataset.bound === 'true') return;
    filterRoot.dataset.bound = 'true';

    var searchInput = filterRoot.querySelector('[data-sc-scent-search]');
    var chips = filterRoot.querySelector('[data-sc-scent-chips]');

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        if (!filterReady) initFilter();
        filterScents(searchInput.value, null);
      });
    }

    if (chips) {
      chips.addEventListener('click', function (event) {
        var chip = event.target.closest('[data-sc-scent-category]');
        if (!chip) return;

        if (!filterReady) initFilter();

        var nextCategory = chip.getAttribute('data-sc-scent-category') || 'alle';
        var categoryChanged = nextCategory !== filterState.category;

        chips.querySelectorAll('[data-sc-scent-category]').forEach(function (button) {
          var active = button === chip;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        filterScents(null, nextCategory);

        if (categoryChanged) {
          window.setTimeout(scrollToFilteredResults, 60);
        }
      });
    }
  }

  function refreshFilter() {
    if (!filterReady) return;
    tagAllFilterableItems(false);
    filterScents(filterState.query, filterState.category);
  }

  function initFilter() {
    if (filterReady) return;
    filterReady = true;
    refreshFilter();
  }

  function scheduleFilterInit() {
    if (filterReady) return;

    var run = function () {
      initFilter();
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 1500 });
    } else {
      setTimeout(run, 300);
    }
  }

  function widgetRoot() {
    return document.getElementById('bundling-app') || document.getElementById('recharge-bundles');
  }

  function isElementVisible(el) {
    if (!el) return false;
    if (el.hidden || el.getAttribute('aria-hidden') === 'true') return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function isButtonDisabled(btn) {
    if (!btn) return true;
    return (
      btn.disabled ||
      btn.getAttribute('aria-disabled') === 'true' ||
      btn.classList.contains('disabled')
    );
  }

  function findRechargeButton() {
    var selectors = [
      '.rb-sticky-form .rb-btn-wrapper .rb-btn',
      '.rb-sticky-form .rb-btn-primary',
      '.rb-sticky-form .rb-btn',
      '.rb-footer .rb-btn',
      '.recharge-bundle-footer button',
      '[class*="bundle-footer"] button',
      '.rb-btn-wrapper .rb-btn',
      '.rb-btn-primary'
    ];

    var fallback = null;

    for (var i = 0; i < selectors.length; i++) {
      var matches = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < matches.length; j++) {
        var btn = matches[j];
        if (!btn || btn.closest('.rb-header')) continue;
        if (!fallback) fallback = btn;
        if (isElementVisible(btn)) return btn;
      }
    }

    return fallback;
  }

  function widgetHasProducts() {
    return findProductCards().length > 0;
  }

  function widgetStillLoading() {
    var root = widgetRoot();
    if (!root) return true;
    if (widgetHasProducts()) return false;
    return !!root.querySelector('.rb-skeleton');
  }

  function getCardActionButtons(card) {
    var contentButtons = card.querySelectorAll(
      '.rb-item-content button, .rb-item-content .rb-btn, .sc-scent-fallback__actions button'
    );
    if (contentButtons.length) {
      return Array.prototype.slice.call(contentButtons);
    }
    return Array.prototype.slice.call(card.querySelectorAll('button'));
  }

  function buttonTextIndicatesSelected(button) {
    if (!button) return false;
    var text = normalizeText((button.textContent || '').replace(/\s+/g, ' '));
    return (
      text.indexOf('fjern') !== -1 ||
      text.indexOf('remove') !== -1 ||
      text.indexOf('valgt') !== -1 ||
      text.indexOf('selected') !== -1 ||
      button.getAttribute('aria-pressed') === 'true' ||
      (button.className || '').toLowerCase().indexOf('selected') !== -1 ||
      (button.className || '').toLowerCase().indexOf('remove') !== -1
    );
  }

  function isCardSelected(card) {
    if (card.getAttribute('data-selected') === 'true') {
      return true;
    }

    var selected =
      card.querySelector('[aria-pressed="true"]') ||
      card.querySelector('.rb-item-selected') ||
      card.querySelector('[data-selected="true"]') ||
      card.querySelector('button[class*="selected"]') ||
      card.querySelector('button[class*="remove"]');

    if (selected) return true;

    return getCardActionButtons(card).some(buttonTextIndicatesSelected);
  }

  function getCardImageSrc(card) {
    var img =
      card.querySelector('.rb-item-img img[src]') ||
      card.querySelector('.rb-item-image img[src]') ||
      card.querySelector('.rb-item-img img[data-src]') ||
      card.querySelector('.sc-scent-fallback__image img[src]') ||
      card.querySelector('img[src]');

    if (!img) return '';

    return (
      img.currentSrc ||
      img.src ||
      img.getAttribute('data-src') ||
      img.getAttribute('src') ||
      ''
    );
  }

  function getSelectedScents() {
    return findProductCards()
      .filter(isCardSelected)
      .map(function (card) {
        return {
          title: getCardTitle(card),
          imageSrc: getCardImageSrc(card)
        };
      })
      .filter(function (scent) {
        return !!(scent.title || scent.imageSrc);
      });
  }

  function getSelectedScentTitles() {
    return getSelectedScents()
      .map(function (scent) {
        return scent.title;
      })
      .filter(function (title) {
        return !!title;
      });
  }

  function getSelectionKey(selectedScents) {
    return selectedScents
      .map(function (scent) {
        return [scent.title, scent.imageSrc].join('::');
      })
      .join('|');
  }

  function renderSingleBarSelection(scent) {
    if (!statusItemsEl) return;

    statusItemsEl.innerHTML = '';

    var list = document.createElement('div');
    list.className = 'sc-scent-bar__item-list sc-scent-bar__item-list--single';

    var item = document.createElement('div');
    item.className = 'sc-scent-bar__item';

    if (scent.imageSrc) {
      var img = document.createElement('img');
      img.className = 'sc-scent-bar__thumb';
      img.width = 40;
      img.height = 40;
      img.decoding = 'async';
      img.src = scent.imageSrc;
      img.alt = scent.title || '';
      item.appendChild(img);
    }

    var label = document.createElement('span');
    label.className = 'sc-scent-bar__item-name';
    label.textContent = formatBarSummary(scent.title || 'Duft valgt');
    item.appendChild(label);
    list.appendChild(item);
    statusItemsEl.appendChild(list);
  }

  function renderMultiBarSelection(selectedScents) {
    if (!statusItemsEl) return;

    statusItemsEl.innerHTML = '';

    var line = document.createElement('div');
    line.className = 'sc-scent-bar__simple-summary';
    var price = getPlanPriceLabel();
    var multiLabel = selectedScents.length + ' dufte valgt';
    line.textContent = price ? price + ' · ' + multiLabel : multiLabel;
    statusItemsEl.appendChild(line);
  }

  function updateBarStatus(selectedScents) {
    if (!statusEl) return;

    var hasSelection = selectedScents.length > 0;

    if (!statusPlaceholderEl || !statusSelectionEl) {
      statusEl.textContent = hasSelection
        ? selectedScents.length === 1
          ? formatBarSummary(selectedScents[0].title)
          : formatBarSummary(selectedScents.length + ' dufte valgt')
        : formatBarSummary('');
      return;
    }

    if (!hasSelection) {
      statusPlaceholderEl.hidden = false;
      statusSelectionEl.hidden = true;
      statusEl.setAttribute('data-empty', 'true');
      if (statusPlaceholderEl) {
        statusPlaceholderEl.textContent = formatBarSummary('');
      }
      return;
    }

    statusPlaceholderEl.hidden = true;
    statusSelectionEl.hidden = false;
    statusEl.removeAttribute('data-empty');

    if (selectedScents.length === 1 && isComboPlan()) {
      renderComboBarSelection(selectedScents[0]);
      return;
    }

    if (selectedScents.length === 1) {
      renderSingleBarSelection(selectedScents[0]);
      return;
    }

    renderMultiBarSelection(selectedScents);
  }

  function clearCountdownTimer() {
    if (!countdown.timer) return;
    clearInterval(countdown.timer);
    countdown.timer = null;
  }

  function restartProgressAnimation() {
    if (!ctaProgressEl) return;
    ctaProgressEl.style.animation = 'none';
    void ctaProgressEl.offsetHeight;
    ctaProgressEl.style.animation = '';
  }

  function clearCtaLoadingTimer() {
    if (!ctaLoadingTimer) return;
    clearTimeout(ctaLoadingTimer);
    ctaLoadingTimer = null;
  }

  function setCtaLoading(loading) {
    if (!ctaEl || !ctaLabelEl) return;
    if (loading === ctaLoading) return;

    ctaLoading = loading;
    clearCtaLoadingTimer();

    var arrowEl = ctaEl.querySelector('.sc-scent-bar__cta-arrow');

    if (loading) {
      clearCountdownTimer();
      countdown.remaining = 0;
      countdown.cancelled = true;

      ctaEl.classList.remove('sc-scent-bar__cta--countdown', 'sc-scent-bar__cta--disabled');
      ctaEl.classList.add('sc-scent-bar__cta--loading');
      ctaEl.disabled = true;
      ctaEl.setAttribute('aria-disabled', 'true');
      ctaEl.setAttribute('aria-busy', 'true');
      ctaLabelEl.textContent = 'Vent...';
      if (arrowEl) arrowEl.hidden = true;
      if (cancelEl) cancelEl.hidden = true;
      if (ctaProgressEl) ctaProgressEl.style.animation = 'none';
      ctaEl.setAttribute('aria-label', 'Vent, vi sender dig videre...');

      ctaLoadingTimer = setTimeout(function () {
        if (!ctaLoading) return;
        setCtaLoading(false);
        syncBar();
      }, CTA_LOADING_TIMEOUT_MS);
      return;
    }

    ctaEl.classList.remove('sc-scent-bar__cta--loading');
    ctaEl.removeAttribute('aria-busy');
  }

  function setCtaMode(mode, seconds) {
    if (!ctaEl || !ctaLabelEl) return;
    if (ctaLoading) return;

    var wasCountdown = ctaEl.classList.contains('sc-scent-bar__cta--countdown');
    ctaEl.classList.remove('sc-scent-bar__cta--disabled');
    if (mode !== 'countdown') {
      ctaEl.classList.remove('sc-scent-bar__cta--countdown');
      if (cancelEl) cancelEl.hidden = true;
    }

    var arrowEl = ctaEl.querySelector('.sc-scent-bar__cta-arrow');

    if (mode === 'disabled') {
      ctaEl.classList.remove('sc-scent-bar__cta--countdown');
      ctaEl.disabled = true;
      ctaEl.classList.add('sc-scent-bar__cta--disabled');
      ctaEl.setAttribute('aria-disabled', 'true');
      ctaLabelEl.textContent = 'Fortsæt';
      if (arrowEl) arrowEl.hidden = true;
      ctaEl.setAttribute('aria-label', 'Vælg en duft for at fortsætte');
      return;
    }

    ctaEl.disabled = false;
    ctaEl.setAttribute('aria-disabled', 'false');

    if (mode === 'countdown') {
      var remaining = seconds != null ? seconds : countdown.remaining;
      if (!wasCountdown) ctaEl.classList.add('sc-scent-bar__cta--countdown');
      ctaLabelEl.textContent = 'Fortsæt om ' + remaining + '...';
      if (cancelEl) cancelEl.hidden = false;
      if (arrowEl) arrowEl.hidden = true;
      ctaEl.setAttribute(
        'aria-label',
        'Fortsæt automatisk om ' + remaining + ' sekunder. Tryk Annuller for at stoppe.'
      );
      if (remaining === COUNTDOWN_SECONDS) restartProgressAnimation();
      return;
    }

    ctaLabelEl.textContent = 'Fortsæt';
    if (arrowEl) arrowEl.hidden = false;
    ctaEl.setAttribute('aria-label', 'Fortsæt til kassen');
  }

  function cancelAutoContinue() {
    clearCountdownTimer();
    countdown.remaining = 0;
    countdown.cancelled = true;
    if (ctaEl && !ctaEl.disabled) setCtaMode('normal');
  }

  function triggerContinue() {
    if (ctaLoading) return;

    clearCountdownTimer();
    countdown.remaining = 0;
    countdown.cancelled = false;

    rechargeBtn = findRechargeButton();
    if (!rechargeBtn || isButtonDisabled(rechargeBtn)) {
      syncBar();
      return;
    }

    setCtaLoading(true);

    try {
      rechargeBtn.click();
    } catch (error) {
      setCtaLoading(false);
      syncBar();
    }
  }

  function startCountdown() {
    clearCountdownTimer();
    countdown.cancelled = false;
    countdown.remaining = COUNTDOWN_SECONDS;
    setCtaMode('countdown', countdown.remaining);

    countdown.timer = setInterval(function () {
      countdown.remaining -= 1;
      if (countdown.remaining <= 0) {
        clearCountdownTimer();
        triggerContinue();
        return;
      }
      setCtaMode('countdown', countdown.remaining);
    }, 1000);
  }

  function fixRechargeButtonTypo() {
    var buttons = document.querySelectorAll(
      '.rb-btn-primary, .rb-btn-wrapper .rb-btn, .recharge-bundle-footer button, .rb-sticky-form .rb-btn'
    );

    buttons.forEach(function (btn) {
      if (!btn || !btn.textContent) return;
      if (btn.textContent.indexOf('Forsæt') === -1) return;
      btn.textContent = btn.textContent.replace(/Forsæt/g, 'Fortsæt');
    });
  }

  function getCardActionButton(card) {
    return (
      card.querySelector('.rb-item-content button:not([disabled])') ||
      card.querySelector('.rb-item-content .rb-btn:not([disabled])') ||
      card.querySelector('button:not([disabled]):not(.rb-btn-primary)')
    );
  }

  function getCardFromTarget(target) {
    return target.closest('.rb-item, .recharge-bundle-product-item, .sc-scent-fallback__card');
  }

  function isImageAreaButton(button) {
    if (!button) return false;
    if (button.closest('.rb-item-content')) return false;
    return !!button.closest('.rb-item-img, .rb-item-learn-more, .rb-img, .sc-scent-fallback__image');
  }

  function isCardImageClick(target, card) {
    if (!card || !target) return false;

    var button = target.closest('button');
    if (button && !isImageAreaButton(button)) return false;

    if (card.classList.contains('sc-scent-fallback__card')) {
      return !!target.closest('.sc-scent-fallback__image');
    }

    if (target.closest('.rb-item-content')) return false;

    if (
      target.closest('.rb-item-img') ||
      target.closest('.rb-item-learn-more') ||
      target.closest('[class*="image"]') ||
      target.closest('[class*="Image"]')
    ) {
      return true;
    }

    if (target.closest('img') && card.contains(target.closest('img'))) return true;

    var imageLink = card.querySelector(':scope > a:first-child');
    return !!(imageLink && imageLink.contains(target));
  }

  function triggerCardSelect(card) {
    if (!card) return false;

    if (card.classList.contains('sc-scent-fallback__card')) {
      var title = card.getAttribute('data-scent-title') || '';
      return selectFallbackScent(title);
    }

    if (card.classList.contains('rb-item--soldout')) return false;

    var btn = getCardActionButton(card);
    if (!btn) return false;

    btn.click();
    scheduleBarSync();
    return true;
  }

  function bindCardImageSelect() {
    var root = widgetRoot();

    function handleCardImageActivate(event) {
      var card = getCardFromTarget(event.target);
      if (!card) return;

      var inWidget = root && root.contains(card);
      var inFallback = card.classList.contains('sc-scent-fallback__card');
      if (!inWidget && !inFallback) return;

      if (!isCardImageClick(event.target, card)) return;

      event.preventDefault();
      event.stopPropagation();
      triggerCardSelect(card);
    }

    document.addEventListener('click', handleCardImageActivate, true);
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var target = event.target;
      if (!target) return;

      var button = target.closest('button');
      if (button && !isImageAreaButton(button)) return;

      var card = getCardFromTarget(target);
      if (!card || !isCardImageClick(target, card)) return;

      event.preventDefault();
      triggerCardSelect(card);
    }, true);
  }

  function fixScentSelectButtonText() {
    findProductCards().forEach(function (card) {
      if (isCardSelected(card)) return;

      var btn = getCardActionButton(card);

      if (!btn) return;

      var text = (btn.textContent || '').replace(/\s+/g, ' ').trim();
      var normalized = normalizeText(text);

      if (
        normalized.indexOf('udsolgt') !== -1 ||
        normalized.indexOf('sold out') !== -1 ||
        normalized.indexOf('fjern') !== -1 ||
        normalized.indexOf('remove') !== -1 ||
        normalized.indexOf('valgt') !== -1 ||
        normalized.indexOf('selected') !== -1
      ) {
        return;
      }

      if (/^\+?\s*v[æa]lg(\s+duft)?$/i.test(text) || /^add(\s+scent)?$/i.test(text)) {
        btn.textContent = 'Vælg';
        btn.setAttribute('aria-label', 'Vælg');
      }
    });
  }

  function disableSoldOutTooltips() {
    document.querySelectorAll('.rb-item--soldout').forEach(function (item) {
      item.querySelectorAll('[aria-describedby]').forEach(function (el) {
        var popperId = el.getAttribute('aria-describedby');
        el.removeAttribute('aria-describedby');
        el.removeAttribute('data-popper-shown');

        if (popperId) {
          var popper = document.getElementById(popperId);
          if (popper) {
            popper.hidden = true;
            popper.classList.add('sc-hide-soldout-tooltip');
          }
        }
      });
    });

    document
      .querySelectorAll('.v-popper__popper.v-popper--theme-info-tooltip.v-popper__popper--shown')
      .forEach(function (popper) {
        if ((popper.textContent || '').trim() === 'Udsolgt') {
          popper.hidden = true;
          popper.classList.add('sc-hide-soldout-tooltip');
        }
      });
  }

  function syncSelectedStates() {
    findProductCards().forEach(function (card) {
      card.classList.toggle('sc-scent-selected', isCardSelected(card));
    });
  }

  function ensureProductImagesVisible() {
    findProductCards().forEach(function (card) {
      card.style.contentVisibility = 'visible';

      card.querySelectorAll('img').forEach(function (img) {
        if (img.complete || img.dataset.scImageReady === 'true') return;
        img.loading = 'eager';
        img.dataset.scImageReady = 'true';
        if (img.src) img.src = img.src;
      });
    });
  }

  function hideSkeleton() {
    var skeleton = document.getElementById(SKELETON_ID);
    if (!skeleton) return;
    skeleton.hidden = true;
    skeleton.setAttribute('aria-hidden', 'true');
    skeleton.setAttribute('aria-busy', 'false');
  }

  function showSkeleton() {
    var skeleton = document.getElementById(SKELETON_ID);
    if (!skeleton) return;
    skeleton.hidden = false;
    skeleton.setAttribute('aria-hidden', 'false');
    skeleton.setAttribute('aria-busy', 'true');
  }

  function syncBar() {
    if (syncing) return;
    syncing = true;

    try {
      fixRechargeButtonTypo();
      fixScentSelectButtonText();

      if (!statusEl || !ctaEl) return;

      rechargeBtn = findRechargeButton();
      var selectedScents = getSelectedScents();
      var hasSelection = selectedScents.length > 0;
      var rechargeDisabled = !rechargeBtn || isButtonDisabled(rechargeBtn);
      var canContinue = hasSelection || !rechargeDisabled;
      var selectionKey = getSelectionKey(selectedScents);

      updateBarStatus(selectedScents);

      if (!ctaLoading) {
        if (!canContinue) {
          clearCountdownTimer();
          countdown.remaining = 0;
          countdown.cancelled = false;
          countdown.selectionKey = '';
          setCtaMode('disabled');
        } else {
          if (selectionKey !== countdown.selectionKey) {
            countdown.selectionKey = selectionKey;
            startCountdown();
          } else if (countdown.timer) {
            ctaEl.disabled = false;
            ctaEl.setAttribute('aria-disabled', 'false');
          } else if (countdown.cancelled) {
            setCtaMode('normal');
          } else {
            setCtaMode('normal');
          }
        }
      }

      if (widgetHasProducts()) {
        hideFallback();
        hideSkeleton();
        ensureProductImagesVisible();
        scheduleProductsReady();
      }

      syncSelectedStates();
      disableSoldOutTooltips();
    } finally {
      syncing = false;
    }
  }

  function scheduleBarSync() {
    if (barDebounceTimer) clearTimeout(barDebounceTimer);
    barDebounceTimer = setTimeout(function () {
      barDebounceTimer = null;
      syncBar();
    }, 120);

    // Recharge updates card state asynchronously after click.
    setTimeout(function () {
      syncBar();
    }, 320);
  }

  function scheduleProductsReady() {
    var count = findProductCards().length;
    var countChanged = count !== lastProductCount;
    if (countChanged) {
      lastProductCount = count;
      productsTagged = false;
    }

    if (productsStableTimer) clearTimeout(productsStableTimer);
    productsStableTimer = setTimeout(function () {
      productsStableTimer = null;
      if (!widgetHasProducts()) return;

      if (filterReady) {
        refreshFilter();
      } else {
        scheduleFilterInit();
      }
      switchToFooterObserver();
    }, countChanged ? 400 : 200);
  }

  function createBar() {
    if (document.getElementById(BAR_ID)) return;

    var wrap = document.createElement('div');
    wrap.id = 'sc-scent-bar-wrap';
    wrap.className = 'sc-scent-bar-wrap';
    wrap.setAttribute('role', 'complementary');
    wrap.setAttribute('aria-label', 'Fortsæt med valgt duft');

    wrap.innerHTML =
      '<div class="sc-scent-bar__trust" aria-label="Fordele ved Scenty">' +
      '  <span class="sc-scent-bar__trust-item">Ingen binding</span>' +
      '  <span class="sc-scent-bar__trust-item">Skift duft hver måned</span>' +
      '  <span class="sc-scent-bar__trust-item">Opsig når som helst</span>' +
      '</div>' +
      '<div id="' +
      BAR_ID +
      '" class="sc-scent-bar">' +
      '  <div class="sc-scent-bar__info">' +
      '    <div class="sc-scent-bar__label">Dit abonnement</div>' +
      '    <div class="sc-scent-bar__status" id="sc-scent-bar-status" data-empty="true">' +
      '      <span class="sc-scent-bar__placeholder" id="sc-scent-bar-placeholder">Vælg en duft</span>' +
      '      <span class="sc-scent-bar__selection" id="sc-scent-bar-selection" hidden>' +
      '        <div class="sc-scent-bar__items" id="sc-scent-bar-items"></div>' +
      '      </span>' +
      '    </div>' +
      '  </div>' +
      '  <div class="sc-scent-bar__actions">' +
      '    <button type="button" class="sc-scent-bar__cta sc-scent-bar__cta--disabled" id="sc-scent-bar-cta" disabled aria-disabled="true" aria-label="Vælg en duft for at fortsætte">' +
      '      <span class="sc-scent-bar__cta-progress" aria-hidden="true"></span>' +
      '      <span class="sc-scent-bar__cta-label">Fortsæt</span>' +
      '      <svg class="sc-scent-bar__cta-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" hidden>' +
      '        <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>' +
      '      </svg>' +
      '    </button>' +
      '    <button type="button" class="sc-scent-bar__cancel" id="sc-scent-bar-cancel" hidden>Annuller</button>' +
      '  </div>' +
      '</div>';

    document.body.appendChild(wrap);

    loadPlanMeta();
    var placeholderEl = document.getElementById('sc-scent-bar-placeholder');
    if (placeholderEl) {
      placeholderEl.textContent = formatBarSummary('');
    }

    statusEl = document.getElementById('sc-scent-bar-status');
    statusPlaceholderEl = document.getElementById('sc-scent-bar-placeholder');
    statusSelectionEl = document.getElementById('sc-scent-bar-selection');
    statusItemsEl = document.getElementById('sc-scent-bar-items');
    statusThumbEl = null;
    statusNameEl = null;
    ctaEl = document.getElementById('sc-scent-bar-cta');
    cancelEl = document.getElementById('sc-scent-bar-cancel');
    ctaLabelEl = ctaEl.querySelector('.sc-scent-bar__cta-label');
    ctaProgressEl = ctaEl.querySelector('.sc-scent-bar__cta-progress');

    ctaEl.addEventListener('click', function () {
      if (ctaEl.disabled || ctaLoading) return;
      triggerContinue();
    });

    cancelEl.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      cancelAutoContinue();
    });

    document.documentElement.style.setProperty(
      '--sc-sticky-offset',
      wrap.offsetHeight + 'px'
    );
  }

  function detectGender(text) {
    var normalized = normalizeText(text);
    var mand = 0;
    var kvinde = 0;

    normalizedGenderKeywords.mand.forEach(function (keyword) {
      if (normalized.indexOf(keyword) !== -1) mand += 1;
    });
    normalizedGenderKeywords.kvinde.forEach(function (keyword) {
      if (normalized.indexOf(keyword) !== -1) kvinde += 1;
    });

    if (mand > kvinde) return 'mand';
    if (kvinde > mand) return 'kvinde';
    return 'neutral';
  }

  function scoreScentCard(item, answers) {
    tagFilterableItem(item);

    var searchText = item.getAttribute('data-sc-search-text') || '';
    var categories = (item.getAttribute('data-sc-categories') || '').split(',').filter(Boolean);
    var score = 0;

    (SCENT_QUIZ_PROFILES[answers.profile] || []).forEach(function (category) {
      if (categories.indexOf(category) !== -1) score += 3;
    });

    (SCENT_QUIZ_OCCASION[answers.occasion] || []).forEach(function (category) {
      if (categories.indexOf(category) !== -1) score += 2;
    });

    var gender = detectGender(searchText);
    if (answers.preference === 'mand' && gender === 'mand') score += 2;
    if (answers.preference === 'kvinde' && gender === 'kvinde') score += 2;
    if (answers.preference === 'neutral' && gender === 'neutral') score += 1;

    return score;
  }

  function getVisibleScentCards() {
    tagAllFilterableItems(true);
    return getFilterableItems().filter(function (item) {
      return !item.classList.contains('sc-scent-hidden');
    });
  }

  function recommendScentFromQuiz(answers) {
    var cards = getVisibleScentCards();
    if (!cards.length) return null;

    var bestCard = null;
    var bestScore = -1;

    cards.forEach(function (card) {
      var score = scoreScentCard(card, answers);
      if (score > bestScore) {
        bestScore = score;
        bestCard = card;
      }
    });

    if (!bestCard || bestScore <= 0) {
      bestCard = cards[Math.floor(Math.random() * cards.length)];
    }

    return bestCard;
  }

  function highlightRecommendedCard(card) {
    if (!card) return;

    card.classList.add('sc-scent-quiz-highlight');
    window.setTimeout(function () {
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 120);

    window.setTimeout(function () {
      card.classList.remove('sc-scent-quiz-highlight');
    }, 3200);
  }

  function initScentQuiz() {
    var openBtn = document.querySelector('[data-sc-scent-quiz-open]');
    if (!openBtn || openBtn.dataset.bound === 'true') return;
    openBtn.dataset.bound = 'true';

    var modal = document.createElement('div');
    modal.className = 'sc-scent-quiz';
    modal.id = 'sc-scent-quiz';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="sc-scent-quiz__backdrop" data-sc-scent-quiz-close tabindex="-1"></div>' +
      '<div class="sc-scent-quiz__dialog" role="dialog" aria-modal="true" aria-labelledby="sc-scent-quiz-title">' +
      '  <button type="button" class="sc-scent-quiz__close" data-sc-scent-quiz-close aria-label="Luk">×</button>' +
      '  <div class="sc-scent-quiz__progress-wrap" aria-hidden="true"><span class="sc-scent-quiz__progress" data-sc-scent-quiz-progress></span></div>' +
      '  <div class="sc-scent-quiz__step" data-sc-scent-quiz-step="profile">' +
      '    <h2 class="sc-scent-quiz__title" id="sc-scent-quiz-title">Hvilken duftprofil kan du lide?</h2>' +
      '    <p class="sc-scent-quiz__sub">Vi finder en duft, der passer til dig.</p>' +
      '    <div class="sc-scent-quiz__options">' +
      '      <button type="button" class="sc-scent-quiz__option" data-sc-scent-quiz-answer="profile" data-sc-scent-quiz-value="frisk"><strong>Frisk</strong><span>Let og opkvikkende</span></button>' +
      '      <button type="button" class="sc-scent-quiz__option" data-sc-scent-quiz-answer="profile" data-sc-scent-quiz-value="blomstret"><strong>Blomstret</strong><span>Blød og elegant</span></button>' +
      '      <button type="button" class="sc-scent-quiz__option" data-sc-scent-quiz-answer="profile" data-sc-scent-quiz-value="warm"><strong>Varm</strong><span>Dyb og sensuel</span></button>' +
      '    </div>' +
      '  </div>' +
      '  <div class="sc-scent-quiz__step" data-sc-scent-quiz-step="occasion" hidden>' +
      '    <h2 class="sc-scent-quiz__title">Hvornår vil du bruge duften?</h2>' +
      '    <p class="sc-scent-quiz__sub">Vælg det, der passer bedst til dig.</p>' +
      '    <div class="sc-scent-quiz__options">' +
      '      <button type="button" class="sc-scent-quiz__option" data-sc-scent-quiz-answer="occasion" data-sc-scent-quiz-value="dag"><strong>Til hverdagen</strong><span>Let og frisk til dagtimerne</span></button>' +
      '      <button type="button" class="sc-scent-quiz__option" data-sc-scent-quiz-answer="occasion" data-sc-scent-quiz-value="aften"><strong>Til aftenen</strong><span>Mere intens og varm</span></button>' +
      '    </div>' +
      '  </div>' +
      '  <div class="sc-scent-quiz__step" data-sc-scent-quiz-step="preference" hidden>' +
      '    <h2 class="sc-scent-quiz__title">Hvilken type duft leder du efter?</h2>' +
      '    <p class="sc-scent-quiz__sub">Det hjælper os med at finde den rigtige match.</p>' +
      '    <div class="sc-scent-quiz__options">' +
      '      <button type="button" class="sc-scent-quiz__option" data-sc-scent-quiz-answer="preference" data-sc-scent-quiz-value="mand"><strong>Til mænd</strong><span>Maskuline og markante dufte</span></button>' +
      '      <button type="button" class="sc-scent-quiz__option" data-sc-scent-quiz-answer="preference" data-sc-scent-quiz-value="kvinde"><strong>Til kvinder</strong><span>Feminine og blomstrede dufte</span></button>' +
      '      <button type="button" class="sc-scent-quiz__option" data-sc-scent-quiz-answer="preference" data-sc-scent-quiz-value="neutral"><strong>Neutral</strong><span>Passer til alle</span></button>' +
      '    </div>' +
      '  </div>' +
      '  <div class="sc-scent-quiz__step" data-sc-scent-quiz-step="result" hidden>' +
      '    <h2 class="sc-scent-quiz__title">Vi har fundet en duft til dig</h2>' +
      '    <p class="sc-scent-quiz__sub" data-sc-scent-quiz-result-text>Vi fremhæver den anbefalede duft nedenfor.</p>' +
      '    <button type="button" class="sc-scent-quiz__done sc-btn sc-btn--gold sc-btn--md" data-sc-scent-quiz-close>Se min anbefaling</button>' +
      '  </div>' +
      '</div>';

    document.body.appendChild(modal);

    var steps = Array.prototype.slice.call(modal.querySelectorAll('[data-sc-scent-quiz-step]'));
    var progressEl = modal.querySelector('[data-sc-scent-quiz-progress]');
    var resultTextEl = modal.querySelector('[data-sc-scent-quiz-result-text]');
    var currentStep = 0;
    var answers = {};
    var lastFocus = null;

    function showQuizStep(index) {
      steps.forEach(function (step, i) {
        step.hidden = i !== index;
      });
      currentStep = index;

      if (progressEl) {
        var pct = steps.length > 1 ? Math.round((index / (steps.length - 1)) * 100) : 0;
        progressEl.style.width = pct + '%';
      }
    }

    function openQuiz() {
      lastFocus = document.activeElement;
      answers = {};
      modal.querySelectorAll('.sc-scent-quiz__option.is-selected').forEach(function (btn) {
        btn.classList.remove('is-selected');
      });
      showQuizStep(0);
      modal.hidden = false;
      document.body.classList.add('sc-scent-quiz-open');
      var firstOption = modal.querySelector('.sc-scent-quiz__option');
      if (firstOption) firstOption.focus();
    }

    function closeQuiz() {
      modal.hidden = true;
      document.body.classList.remove('sc-scent-quiz-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openBtn.addEventListener('click', openQuiz);

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-sc-scent-quiz-close]')) {
        closeQuiz();
        return;
      }

      var option = event.target.closest('[data-sc-scent-quiz-answer]');
      if (!option) return;

      var key = option.getAttribute('data-sc-scent-quiz-answer');
      var value = option.getAttribute('data-sc-scent-quiz-value');
      answers[key] = value;

      modal.querySelectorAll('[data-sc-scent-quiz-answer="' + key + '"]').forEach(function (btn) {
        btn.classList.toggle('is-selected', btn === option);
      });

      window.setTimeout(function () {
        if (currentStep >= steps.length - 2) {
          var card = recommendScentFromQuiz(answers);
          var title = getCardTitle(card) || 'din anbefalede duft';

          if (resultTextEl) {
            resultTextEl.textContent = 'Vi anbefaler ' + title + '. Vi fremhæver den nedenfor.';
          }

          showQuizStep(steps.length - 1);

          window.setTimeout(function () {
            closeQuiz();
            if (card) {
              triggerCardSelect(card);
              highlightRecommendedCard(card);
            }
          }, 480);
          return;
        }

        showQuizStep(currentStep + 1);
      }, 220);
    });

    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeQuiz();
      }
    });
  }

  function showFallback() {
    var fallback = document.getElementById(FALLBACK_ID);
    if (!fallback || widgetHasProducts()) return;
    fallback.hidden = false;
    fallback.setAttribute('aria-hidden', 'false');
    hideSkeleton();

    var widgetSection = document.querySelector('[class*="recharge-bundles-widget"]');
    if (widgetSection) {
      widgetSection.setAttribute('data-sc-widget-hidden', 'true');
    }

    productsTagged = false;
    scheduleFilterInit();
  }

  function hideFallback() {
    var fallback = document.getElementById(FALLBACK_ID);
    if (!fallback) return;
    fallback.hidden = true;
    fallback.setAttribute('aria-hidden', 'true');

    var widgetSection = document.querySelector('[class*="recharge-bundles-widget"]');
    if (widgetSection) {
      widgetSection.removeAttribute('data-sc-widget-hidden');
    }
  }

  function selectFallbackScent(title) {
    if (!title) return false;

    var cards = findProductCards();
    var normalized = title.toLowerCase().trim();

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var cardTitle = card.querySelector('.rb-item-title, [class*="title"], h3, h4');
      var cardText = cardTitle ? (cardTitle.textContent || '').toLowerCase().trim() : '';
      if (!cardText || cardText.indexOf(normalized) === -1) continue;

      var btn = getCardActionButton(card);
      if (btn) {
        btn.click();
        hideFallback();
        scheduleBarSync();
        return true;
      }
    }

    return false;
  }

  function bindFallbackActions() {
    var fallback = document.getElementById(FALLBACK_ID);
    if (!fallback || fallback.dataset.bound === 'true') return;
    fallback.dataset.bound = 'true';

    fallback.addEventListener('click', function (event) {
      var button = event.target.closest('[data-scent-select]');
      if (!button) return;

      var card = button.closest('[data-scent-title]');
      var title = card ? card.getAttribute('data-scent-title') : '';
      if (selectFallbackScent(title)) return;

      document.dispatchEvent(new CustomEvent('recharge:bundles-widget:reload'));
      setTimeout(function () {
        if (!selectFallbackScent(title)) {
          window.location.reload();
        }
      }, 2500);
    });
  }

  function startBootObserver() {
    var root = widgetRoot();
    if (!root || widgetObserver) return;

    widgetObserver = new MutationObserver(function () {
      if (widgetHasProducts()) {
        ensureProductImagesVisible();
        scheduleBarSync();
        disableSoldOutTooltips();
        scheduleProductsReady();
      }
    });

    widgetObserver.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'aria-describedby',
        'data-popper-shown',
        'class',
        'disabled',
        'aria-disabled',
        'aria-pressed',
        'data-selected'
      ]
    });
  }

  function switchToFooterObserver() {
    if (footerObserver) return;

    var footer =
      document.querySelector('.rb-footer') ||
      document.querySelector('.recharge-bundle-footer') ||
      document.querySelector('.rb-sticky-form .rb-btn-wrapper') ||
      document.querySelector('.rb-sticky-form') ||
      document.querySelector('.rb-btn-wrapper');

    if (!footer) return;

    footerObserver = new MutationObserver(scheduleBarSync);
    footerObserver.observe(footer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class']
    });
  }

  function waitForWidgetReady(callback) {
    var root = widgetRoot();
    if (!root) {
      callback();
      return;
    }

    if (widgetHasProducts()) {
      callback();
      return;
    }

    var bootObserver = new MutationObserver(function () {
      if (widgetHasProducts() || (!widgetStillLoading() && root.querySelector('.rb-app'))) {
        bootObserver.disconnect();
        callback();
      }
    });

    bootObserver.observe(root, { childList: true, subtree: true });

    setTimeout(function () {
      bootObserver.disconnect();
      callback();
    }, 8000);
  }

  function init() {
    createBar();
    bindFallbackActions();
    bindCardImageSelect();
    bindFilterControls();
    initFilterPin();
    initScentQuiz();
    showSkeleton();
    startBootObserver();

    waitForWidgetReady(function () {
      scheduleBarSync();

      if (widgetStillLoading() && !widgetHasProducts()) {
        showFallback();
      }
    });

    document.addEventListener('click', scheduleBarSync, true);
    document.addEventListener('mouseover', disableSoldOutTooltips, true);
    document.addEventListener('recharge:bundles-widget:reload', scheduleBarSync);
    document.addEventListener('scenty:campaign:applied', scheduleBarSync);

    setTimeout(function () {
      if (widgetStillLoading() && !widgetHasProducts()) {
        showFallback();
        document.dispatchEvent(new CustomEvent('recharge:bundles-widget:reload'));
      }
    }, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
